import React, { useEffect, useState, useRef } from 'react'
import { Button, Card, Form, Select, DatePicker, Checkbox, Skeleton, message, Table } from "antd";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useSelector } from "react-redux";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import dayjs from "dayjs";
import * as echarts from 'echarts';
import "../../../../../../App.css"
import * as XLSX from "xlsx";
import {
    generatedISOFormatDateString,
    getLastDayRange,
    getLastDayTimeRangeUTC,
} from "../../../../../../Utils/DateConverstion";
import { useCallback } from 'react';


const GroupReport = () => {
    const [groupname, setGroupname] = useState([]);
    const { makeRequest } = useStoreUpdaterWithAPI();
    const [fromDateObj, setFromDateObj] = useState(null);
    const [fromDateString, setFromDateString] = useState(null);
    const [toDateObj, setToDateObj] = useState(null);
    const [toDateString, setToDateString] = useState(null);
    const [isLast24Hours, setIsLast24Hours] = useState(false);
    const [fromDateError, setFromDateError] = useState();
    const [toDateError, setToDateError] = useState();
    const [time, setTime] = useState(false);
    const [to, setTo] = useState(null);
    const [from, setFrom] = useState(null);
    const mode = useSelector((state) => state.darkMode);
    const { isdarkMode } = mode;
    const [groupID, setGroupId] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(true)
    const chartRef = useRef(null);
    const [subGroupData, setSubGroupData] = useState([]);
    const [groupDetails, setGroupDetails] = useState([]);
    const [showData, setShowData] = useState(false);
    const [chartExcel, setChartExcel] = useState([]);
    const [excelToDate, setExcelToDate] = useState(null);
    const [excelFromDate, setExcelFromDate] = useState(null);

    setTimeout(() => {
        setLoading(false)
    }, 2000)

    useEffect(() => {
        makeRequest({
            type: APIConstants.POST,
            url: `${APIConstants.ELECTRICAL_GROUP_NAME}`,
        }).then((res) => {
            if(res){
                setGroupname(res);
            }
        });
    }, [])

    const onChangeFromDate = (date, dateString) => {
        setFromDateString(dateString);
        setFromDateObj(date);
        if (dateString) {
            setFromDateError("");
        }
    };

    const onChangeToDate = (date, dateString) => {
        setToDateString(dateString);
        setToDateObj(date);
        if (dateString) {
            setToDateError("");
        }
    };

    const handleTimeRangeChange = () => {
        console.log('first')
        const range = getLastDayTimeRangeUTC();
        console.log('From:', range.from);
        console.log('To:', range.to); 

        console.log(getLastDayRange())
        const now = dayjs();
        const fromTime = now.subtract(24, "hour");
        const fromTimeString = fromTime.format("YYYY-MM-DD HH:mm:ss");
        const toTimeString = now.format("YYYY-MM-DD HH:mm:ss");
        console.log(toTimeString)
        setFromDateObj(null);
        setToDateObj(null);
        setFromDateString(range.from);
        setToDateString(range.to);
        setFrom(range.from);
        setTo(range.to);
        // setFromDateString(fromTimeString);
        // setToDateString(toTimeString);
        // setFrom(fromTimeString);
        // setTo(toTimeString);
    }; 

    const handleCheckboxChange = (e) => {
        const { checked } = e.target;
        setIsLast24Hours(checked);
        setTime(!checked);

        if (checked) {
            handleTimeRangeChange();
        } else {
            setFromDateString(null);
            setToDateString(null);
            setFromDateObj(null);
            setToDateObj(null);
        }
    };

    const setInputData = () => {
        const fromDate = new Date(fromDateString || new Date());
        const toDate = new Date(toDateString || new Date());

        if (isLast24Hours) {
            // const now = new Date();
            // fromDate.setHours(now.getHours() - 24);
            // toDate.setHours(now.getHours());
        }
        const range = getLastDayTimeRangeUTC();
        console.log('From:', range.from);
        console.log('To:', range.to);
        console.log(isLast24Hours)

        const formattedFromDate = generatedISOFormatDateString(fromDate);
        const formattedToDate = generatedISOFormatDateString(toDate);
        console.log(formattedFromDate)
        console.log(fromDate)

        const inputData1 = {
            GroupId: groupID,
            FromDate: (range.from),
            ToDate: (range.to),
        };
        const inputData2 = {
            GroupId: groupID,
            FromDate: formattedFromDate,
            ToDate: formattedToDate,
        };
        console.log("Date ", inputData2);
        console.log("Date ", inputData1);

        if(isLast24Hours){
            getResponse(inputData1);

        }else{
            getResponse(inputData2);
        }

    };

    const getResponse = (inputData) => {
        setShowData(false)
        console.log(inputData)
        setExcelFromDate(inputData?.FromDate)
        setExcelToDate(inputData?.ToDate)
        makeRequest({
            type: APIConstants.GET,
            url: `${APIConstants.ELECTRICAL_GROPU_REPORT}?GroupID=${inputData.GroupId}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
        }).then((res) => {
            console.log('API Response:', res);

            if (res) {
                if (res.grouptableDetails && Array.isArray(res.grouptableDetails)) {
                    const formattedData = res.grouptableDetails.map(item => ({
                        groupID: item.groupID,
                        groupName: item.groupName,
                        groupConsumption: item.groupConsumption,
                    }));

                    if (res.groupsDetails && Array.isArray(res.groupsDetails)) {
                        const groupDetails = res.groupsDetails.map(item => ({
                            metername: item.metername,
                            openingReading: item.openingReading,
                            closingReading: item.closingReading,
                            finalReading: item.finalReading,
                            siteid: item.siteid,
                            sitename: item.sitename,
                        }));
                        console.log("Group details:", groupDetails);
                    }

                    setRowData(formattedData);
                    console.log("Formatted Data:", formattedData);
                    setSubGroupData(res.subgrouptableDetails);
                    setGroupDetails(res.groupsDetails);
                    console.log("Subgroup Details:", res.subgrouptableDetails);


                    const transformedData = formattedData.map(item => ({
                        name: item.groupName,
                        value: item.groupConsumption,
                    }));
                    setChartData(transformedData);
                    console.log("Transformed Chart Data:", transformedData);
                    setShowData(true)
                    setChartExcel(res)
                    updateChartOptions(transformedData);
                    showData(true)

                } else {
                    message.error("Invalid group data in response.");
                }
            } else {
                message.error("API response is empty or invalid.");
            }
        }).catch((error) => {
            console.error('Error fetching data:', error);
            // message.error("There was an error fetching the data.");
        });
    };


    const handleCreateReport = () => {
        const inputData = { GroupId: groupID };
        setInputData()
    }

    // const exportToExcel = (chartExcel) => {
    //     console.log(chartExcel)
    //     const { grouptableDetails, subgrouptableDetails, groupsDetails } = chartExcel;
    
    //     // Prepare rows for the Excel sheet
    //     const rows = [];
    
    //     grouptableDetails.forEach((group) => {
    //         // Add the group row
    //         rows.push([group.groupID, group.groupName, group.groupConsumption || 0]);
    
    //         // Find subgroups for this group
    //         const subgroups = subgrouptableDetails.filter(
    //             (subgroup) => subgroup.groupID === group.groupID
    //         );
    
    //         subgroups.forEach((subgroup) => {
    //             // Add the subgroup row
    //             rows.push([
    //                 "",
    //                 "Sub GroupID",
    //                 "Sub Group Name",
    //                 "Final Reading",
    //             ]);
    //             rows.push([
    //                 "",
    //                 subgroup.subgroupID,
    //                 subgroup.subgroupName,
    //                 subgroup.subGroupConsumption || 0,
    //             ]);
    
    //             // Add the site details header row
    //             rows.push([
    //                 "",
    //                 "",
    //                 "Site Name",
    //                 "SubGroup ID",
    //                 "Meter ID",
    //                 "Meter Name",
    //                 "Opening Reading",
    //                 "Closing Reading",
    //                 "Final Reading",
    //             ]);
    
    //             // Find site details for this subgroup
    //             const sites = groupsDetails.filter(
    //                 (site) => site.subgroupID === subgroup.subgroupID
    //             );
    
    //             sites.forEach((site) => {
    //                 rows.push([
    //                     "",
    //                     "",
    //                     site.sitename || "",
    //                     site.subgroupID || "",
    //                     site.meterid || "",
    //                     site.metername || "",
    //                     site.openingReading || 0,
    //                     site.closingReading || 0,
    //                     site.finalReading || 0,
    //                 ]);
    //             });
    //         });
    //     });
    
    //     // Define the headers
    //     const headers = [
    //         "Group ID",
    //         "Group Name",
    //         "Total Consumption",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //     ];
    
    //     // Combine headers and rows into a single dataset
    //     const excelData = [headers, ...rows];
    //     console.log("Excel data:", excelData);
    
    //     // Create the Excel workbook and worksheet
    //     const workbook = XLSX.utils.book_new();
    //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "GroupReport");
    
    //     // Generate the filename with a timestamp
    //     const now = new Date();
    //     const timestamp = now
    //         .toLocaleString("en-US", {
    //             year: "numeric",
    //             month: "2-digit",
    //             day: "2-digit",
    //             hour: "2-digit",
    //             minute: "2-digit",
    //             second: "2-digit",
    //             hour12: false,
    //         })
    //         .replace(/[/,: ]/g, "-");
    
    //     const filename = `Group_Report_${timestamp}.xlsx`;
    //     console.log("Generated Filename:", filename);
    
    //     // Write the file to the user's system
    //     XLSX.writeFile(workbook, filename);
    // }
    // const exportToExcel = (chartExcel, fromDate, toDate) => {
    //     console.log(chartExcel);
    //     const { grouptableDetails, subgrouptableDetails, groupsDetails } = chartExcel;
    
    //     // Prepare rows for the Excel sheet
    //     const rows = [];
    
    //     // Add FromDate and ToDate at the top
    //     rows.push(["From Date", fromDate.replace('T',' ').replace('.000Z',' ') || ""]);
    //     rows.push(["To Date", toDate.replace('T',' ').replace('.000Z',' ') || ""]);
    //     rows.push([]); // Blank row for separation
    
    //     grouptableDetails.forEach((group) => {
    //         // Add the group row
    //         rows.push([group.groupID, group.groupName, group.groupConsumption || 0]);
    
    //         // Find subgroups for this group
    //         const subgroups = subgrouptableDetails.filter(
    //             (subgroup) => subgroup.groupID === group.groupID
    //         );
    
    //         subgroups.forEach((subgroup) => {
    //             // Add the subgroup row
    //             rows.push([
    //                 "",
    //                 "Sub GroupID",
    //                 "Sub Group Name",
    //                 "Final Reading",
    //             ]);
    //             rows.push([
    //                 "",
    //                 subgroup.subgroupID,
    //                 subgroup.subgroupName,
    //                 subgroup.subGroupConsumption || 0,
    //             ]);
    
    //             // Add the site details header row
    //             rows.push([
    //                 "",
    //                 "",
    //                 "Site Name",
    //                 "SubGroup ID",
    //                 "Meter ID",
    //                 "Meter Name",
    //                 "Opening Reading",
    //                 "Closing Reading",
    //                 "Final Reading",
    //             ]);
    
    //             // Find site details for this subgroup
    //             const sites = groupsDetails.filter(
    //                 (site) => site.subgroupID === subgroup.subgroupID
    //             );
    
    //             sites.forEach((site) => {
    //                 rows.push([
    //                     "",
    //                     "",
    //                     site.sitename || "",
    //                     site.subgroupID || "",
    //                     site.meterid || "",
    //                     site.metername || "",
    //                     site.openingReading || 0,
    //                     site.closingReading || 0,
    //                     site.finalReading || 0,
    //                 ]);
    //             });
    //         });
    //     });
    
    //     // Define the headers
    //     const headers = [
    //         "Group ID",
    //         "Group Name",
    //         "Total Consumption",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //     ];
    
    //     // Combine headers and rows into a single dataset
    //     const excelData = [headers, ...rows];
    //     console.log("Excel data:", excelData);
    
    //     // Create the Excel workbook and worksheet
    //     const workbook = XLSX.utils.book_new();
    //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "GroupReport");
    
    //     // Generate the filename with a timestamp
    //     const now = new Date();
    //     const timestamp = now
    //         .toLocaleString("en-US", {
    //             year: "numeric",
    //             month: "2-digit",
    //             day: "2-digit",
    //             hour: "2-digit",
    //             minute: "2-digit",
    //             second: "2-digit",
    //             hour12: false,
    //         })
    //         .replace(/[/,: ]/g, "-");
    
    //     const filename = `Group_Report_${timestamp}.xlsx`;
    //     console.log("Generated Filename:", filename);
    
    //     // Write the file to the user's system
    //     XLSX.writeFile(workbook, filename);
    // };
    
    const updateChartOptions = (data) => {
        const chartInstance = echarts.init(chartRef.current);
        const option = {
            title: {},
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'horizontal',
                bottom: "0px",
                textStyle: {
                    color: isdarkMode ? 'white' : 'black',
                },
            },
            toolbox: {
                show: true,
                orient: 'horizontal',
                left: 'right',
                top: 'top',
                feature: {
                    // myExport: {
                    //     show: true,
                    //     title: "Export to Excel",
                    //     icon: "path://M5 0L15 10L5 20Z",
                    //     onclick: () => {
                    //         console.log(chartExcel)
                    //         const { grouptableDetails, subgrouptableDetails, groupsDetails } = chartExcel;
                        
                    //         // Prepare rows for the Excel sheet
                    //         const rows = [];
                        
                    //         grouptableDetails.forEach((group) => {
                    //             // Add the group row
                    //             rows.push([group.groupID, group.groupName, group.groupConsumption || 0]);
                        
                    //             // Find subgroups for this group
                    //             const subgroups = subgrouptableDetails.filter(
                    //                 (subgroup) => subgroup.groupID === group.groupID
                    //             );
                        
                    //             subgroups.forEach((subgroup) => {
                    //                 // Add the subgroup row
                    //                 rows.push([
                    //                     "",
                    //                     "Sub GroupID",
                    //                     "Sub Group Name",
                    //                     "Final Reading",
                    //                 ]);
                    //                 rows.push([
                    //                     "",
                    //                     subgroup.subgroupID,
                    //                     subgroup.subgroupName,
                    //                     subgroup.subGroupConsumption || 0,
                    //                 ]);
                        
                    //                 // Add the site details header row
                    //                 rows.push([
                    //                     "",
                    //                     "",
                    //                     "Site Name",
                    //                     "SubGroup ID",
                    //                     "Meter ID",
                    //                     "Meter Name",
                    //                     "Opening Reading",
                    //                     "Closing Reading",
                    //                     "Final Reading",
                    //                 ]);
                        
                    //                 // Find site details for this subgroup
                    //                 const sites = groupsDetails.filter(
                    //                     (site) => site.subgroupID === subgroup.subgroupID
                    //                 );
                        
                    //                 sites.forEach((site) => {
                    //                     rows.push([
                    //                         "",
                    //                         "",
                    //                         site.sitename || "",
                    //                         site.subgroupID || "",
                    //                         site.meterid || "",
                    //                         site.metername || "",
                    //                         site.openingReading || 0,
                    //                         site.closingReading || 0,
                    //                         site.finalReading || 0,
                    //                     ]);
                    //                 });
                    //             });
                    //         });
                        
                    //         // Define the headers
                    //         const headers = [
                    //             "Group ID",
                    //             "Group Name",
                    //             "Total Consumption",
                    //             "",
                    //             "",
                    //             "",
                    //             "",
                    //             "",
                    //         ];
                        
                    //         // Combine headers and rows into a single dataset
                    //         const excelData = [headers, ...rows];
                    //         console.log("Excel data:", excelData);
                        
                    //         // Create the Excel workbook and worksheet
                    //         const workbook = XLSX.utils.book_new();
                    //         const worksheet = XLSX.utils.aoa_to_sheet(excelData);
                    //         XLSX.utils.book_append_sheet(workbook, worksheet, "GroupReport");
                        
                    //         // Generate the filename with a timestamp
                    //         const now = new Date();
                    //         const timestamp = now
                    //             .toLocaleString("en-US", {
                    //                 year: "numeric",
                    //                 month: "2-digit",
                    //                 day: "2-digit",
                    //                 hour: "2-digit",
                    //                 minute: "2-digit",
                    //                 second: "2-digit",
                    //                 hour12: false,
                    //             })
                    //             .replace(/[/,: ]/g, "-");
                        
                    //         const filename = `Group_Report_${timestamp}.xlsx`;
                    //         console.log("Generated Filename:", filename);
                        
                    //         // Write the file to the user's system
                    //         XLSX.writeFile(workbook, filename);
                    //     },
                    // },
                    mark: { show: true },
                    saveAsImage: { show: true },
                },
                iconStyle: {
                    borderColor: isdarkMode ? 'white' : 'black',
                },
                emphasis: {
                    iconStyle: {
                        borderColor: isdarkMode ? '#FFD700' : '#1E90FF',
                    },
                },
            },
            series: [
                {
                    name: 'Group Consumption',
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        chartInstance.setOption(option);
        
    };
    const exportToExcel = (chartExcel, fromDate, toDate) => {
        console.log(chartExcel);
        const { grouptableDetails, subgrouptableDetails, groupsDetails } = chartExcel;
    
        // Format the dates
        const formattedFromDate = fromDate.replace('T', ' ').replace('.000Z', ' ') || "";
        const formattedToDate = toDate.replace('T', ' ').replace('.000Z', ' ') || "";
    
        // Prepare rows for the Excel sheet
        const rows = [];
    
        // Define the headers
        const headers = [
            "Group ID",
            "Group Name",
            "Total Consumption",
            "",
            "",
            "",
            "",
            "",
            // "From Date",
            // "To Date",
        ];
    
        rows.push(headers);
    
        grouptableDetails.forEach((group) => {
            // Add the group row
            rows.push([
                group.groupID,
                group.groupName,
                group.groupConsumption || 0,
                "",
                "",
                "",
                "",
                "",
                "", // Leave "From Date" blank
                "", // Leave "To Date" blank
            ]);
    
            // Find subgroups for this group
            const subgroups = subgrouptableDetails.filter(
                (subgroup) => subgroup.groupID === group.groupID
            );
    
            subgroups.forEach((subgroup) => {
                // Add the subgroup row
                rows.push([
                    "",
                    "Sub GroupID",
                    "Sub Group Name",
                    "Final Reading",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "", // Leave "From Date" blank
                    "", // Leave "To Date" blank
                ]);
                rows.push([
                    "",
                    subgroup.subgroupID,
                    subgroup.subgroupName,
                    subgroup.subGroupConsumption || 0,
                    "",
                    "",
                    "",
                    "",
                    "",
                    "", // Leave "From Date" blank
                    "", // Leave "To Date" blank
                ]);
    
                // Add the site details header row
                rows.push([
                    "",
                    "",
                    "Site Name",
                    "SubGroup ID",
                    "Meter ID",
                    "Meter Name",
                    "Opening Reading",
                    "Closing Reading",
                    "Final Reading",
                    "",
                    "", // Leave "From Date" blank
                ]);
    
                // Find site details for this subgroup
                const sites = groupsDetails.filter(
                    (site) => site.subgroupID === subgroup.subgroupID
                );
    
                sites.forEach((site) => {
                    rows.push([
                        "",
                        "",
                        site.sitename || "",
                        site.subgroupID || "",
                        site.meterid || "",
                        site.metername || "",
                        site.openingReading || 0,
                        site.closingReading || 0,
                        site.finalReading || 0,
                        "", // Leave "From Date" blank
                        "", // Leave "To Date" blank
                    ]);
                });
            });
        });
    
        // Add the From Date and To Date at the end of the rows
        rows.push([]);
        rows.push([
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "From Date",
            formattedFromDate,
        ]);
        rows.push([
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "To Date",
            formattedToDate,
        ]);
    
        // Create the Excel workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(rows);
    
        // Apply styles for alternate rows and date rows
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
            for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
                const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                if (!worksheet[cellAddress]) continue;
    
                // Get the cell object
                const cell = worksheet[cellAddress];
    
                // Apply background color
                if (rowNum % 2 === 1) {
                    cell.s = {
                        fill: { fgColor: { rgb: "D3D3D3" } }, // Light grey for alternate rows
                    };
                }
    
                // Apply color for "From Date" and "To Date" rows
                if (rowNum === rows.length - 2 || rowNum === rows.length - 1) {
                    cell.s = {
                        fill: { fgColor: { rgb: "FFFF00" } }, // Yellow for date rows
                    };
                }
            }
        }
    
        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "GroupReport");
    
        // Generate the filename with a timestamp
        const now = new Date();
        const timestamp = now
            .toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            })
            .replace(/[/,: ]/g, "-");
    
        const filename = `Group_Report_${timestamp}.xlsx`;
        console.log("Generated Filename:", filename);
    
        // Write the file to the user's system
        XLSX.writeFile(workbook, filename);
    };
    
    // const exportToExcel = (chartExcel, fromDate, toDate) => {
    //     console.log(chartExcel);
    //     const { grouptableDetails, subgrouptableDetails, groupsDetails } = chartExcel;
    
    //     // Format the dates
    //     const formattedFromDate = fromDate.replace('T', ' ').replace('.000Z', ' ') || "";
    //     const formattedToDate = toDate.replace('T', ' ').replace('.000Z', ' ') || "";
    
    //     // Prepare rows for the Excel sheet
    //     const rows = [];
    
    //     // Define the headers
    //     const headers = [
    //         "Group ID",
    //         "Group Name",
    //         "Total Consumption",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //     ];
    
    //     rows.push(headers);
    
    //     grouptableDetails.forEach((group) => {
    //         // Add the group row
    //         rows.push([
    //             group.groupID,
    //             group.groupName,
    //             group.groupConsumption || 0,
    //             "",
    //             "",
    //             "",
    //             "",
    //             "",
    //         ]);
    
    //         // Find subgroups for this group
    //         const subgroups = subgrouptableDetails.filter(
    //             (subgroup) => subgroup.groupID === group.groupID
    //         );
    
    //         subgroups.forEach((subgroup) => {
    //             // Add the subgroup row
    //             rows.push([
    //                 "",
    //                 "Sub GroupID",
    //                 "Sub Group Name",
    //                 "Final Reading",
    //                 "",
    //                 "",
    //                 "",
    //                 "",
    //             ]);
    //             rows.push([
    //                 "",
    //                 subgroup.subgroupID,
    //                 subgroup.subgroupName,
    //                 subgroup.subGroupConsumption || 0,
    //                 "",
    //                 "",
    //                 "",
    //                 "",
    //             ]);
    
    //             // Add the site details header row
    //             rows.push([
    //                 "",
    //                 "",
    //                 "Site Name",
    //                 "SubGroup ID",
    //                 "Meter ID",
    //                 "Meter Name",
    //                 "Opening Reading",
    //                 "Closing Reading",
    //                 "Final Reading",
    //             ]);
    
    //             // Find site details for this subgroup
    //             const sites = groupsDetails.filter(
    //                 (site) => site.subgroupID === subgroup.subgroupID
    //             );
    
    //             sites.forEach((site) => {
    //                 rows.push([
    //                     "",
    //                     "",
    //                     site.sitename || "",
    //                     site.subgroupID || "",
    //                     site.meterid || "",
    //                     site.metername || "",
    //                     site.openingReading || 0,
    //                     site.closingReading || 0,
    //                     site.finalReading || 0,
    //                 ]);
    //             });
    //         });
    //     });
    
    //     // Add the From Date and To Date at the end of the rows
    //     rows.push([]);
    //     rows.push([
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "From Date",
    //         formattedFromDate,
    //     ]);
    //     rows.push([
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "",
    //         "To Date",
    //         formattedToDate,
    //     ]);
    
    //     // Create the Excel workbook and worksheet
    //     const workbook = XLSX.utils.book_new();
    //     const worksheet = XLSX.utils.aoa_to_sheet(rows);
    
    //     // Apply styles to each row
    //     const range = XLSX.utils.decode_range(worksheet["!ref"]);
    //     for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
    //         for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
    //             const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
    //             if (!worksheet[cellAddress]) continue;
    
    //             // Get the cell object
    //             const cell = worksheet[cellAddress];
    
    //             // Generate a unique color for each row
    //             const color = rowNum % 2 === 0 ? "E6E6FA" : "F5F5DC"; // Lavender for even, beige for odd
    
    //             // Apply background color to the cell
    //             cell.s = {
    //                 fill: { fgColor: { rgb: color } },
    //             };
    //         }
    //     }
    
    //     // Apply unique colors to date rows
    //     const dateRowIndex1 = rows.length - 2;
    //     const dateRowIndex2 = rows.length - 1;
    
    //     for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
    //         const dateCell1 = XLSX.utils.encode_cell({ r: dateRowIndex1, c: colNum });
    //         const dateCell2 = XLSX.utils.encode_cell({ r: dateRowIndex2, c: colNum });
    
    //         if (worksheet[dateCell1]) {
    //             worksheet[dateCell1].s = {
    //                 fill: { fgColor: { rgb: "FFFF00" } }, // Yellow
    //             };
    //         }
    
    //         if (worksheet[dateCell2]) {
    //             worksheet[dateCell2].s = {
    //                 fill: { fgColor: { rgb: "FFFF00" } }, // Yellow
    //             };
    //         }
    //     }
    
    //     // Append the worksheet to the workbook
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "GroupReport");
    
    //     // Generate the filename with a timestamp
    //     const now = new Date();
    //     const timestamp = now
    //         .toLocaleString("en-US", {
    //             year: "numeric",
    //             month: "2-digit",
    //             day: "2-digit",
    //             hour: "2-digit",
    //             minute: "2-digit",
    //             second: "2-digit",
    //             hour12: false,
    //         })
    //         .replace(/[/,: ]/g, "-");
    
    //     const filename = `Group_Report_${timestamp}.xlsx`;
    //     console.log("Generated Filename:", filename);
    
    //     // Write the file to the user's system
    //     XLSX.writeFile(workbook, filename);
    // };
    
    useEffect(() => {
        if (chartRef.current && chartData.length > 0) {
            updateChartOptions(chartData,chartExcel);
        }
    }, [chartData,isdarkMode,chartExcel]);

    const columns = [
        { title: "Group ID", dataIndex: "groupID", key: "groupID" },
        { title: "Group Name", dataIndex: "groupName", key: "groupName" },
        { title: "Group Consumption", dataIndex: "groupConsumption", key: "groupConsumption" },
    ];

    const expandedRowRender = (record) => {
        const groupID = record.groupID;
        console.log(groupID)
        console.log(record)

        const subgroupColumns = [
            { title: "Subgroup ID", dataIndex: "subgroupID", key: "subgroupID" },
            { title: "Subgroup Name", dataIndex: "subgroupName", key: "subgroupName" },
            { title: "Subgroup Consumption", dataIndex: "subGroupConsumption", key: "subGroupConsumption" },
        ];

        const groupColumns = [
            { title: "Site ID", dataIndex: "siteid", key: "siteid" },
            { title: "Sub Group ID", dataIndex: "subgroupID", key: "subgroupID" },
            { title: "Site Name", dataIndex: "sitename", key: "sitename" },
            { title: "Meter Name", dataIndex: "metername", key: "metername" },
            { title: "Opening Reading", dataIndex: "openingReading", key: "openingReading" },
            { title: "Closing Reading", dataIndex: "closingReading", key: "closingReading" },
            { title: "Final Reading", dataIndex: "finalReading", key: "finalReading" },
        ];


        const subgroupData = subGroupData.filter(subgroup => subgroup.groupID === groupID);
        const groupDetailData = groupDetails.filter(detail => detail.groupID === groupID);

        console.log(subgroupData)
        console.log(groupDetailData)
        return ( 
            <div>
                {/* Subgroup Details Table */}
                <Table
                    columns={subgroupColumns}
                    dataSource={subgroupData}
                    rowKey="subgroupID"
                    pagination={false}
                    title={() => 'Subgroup Details'}
                    expandable={{
                        expandedRowRender: (subgroupRecord) => {
                            console.log(subgroupRecord)
                            console.log(groupDetailData) 
                            const grouData = groupDetailData.filter(detail => detail.subgroupID === subgroupRecord.subgroupID);
                            console.log(grouData)
                            return (
                                <Table
                                    columns={groupColumns}
                                    dataSource={groupDetailData.filter(detail => detail.subgroupID === subgroupRecord.subgroupID)}
                                    rowKey="siteid"
                                    pagination={false}
                                    title={() => 'Meter Details'}
                                    className="mt-3"
                                />
                            );
                        },
                        rowExpandable: (subgroupRecord) => true,
                    }}
                />
            </div>
        );
    };

    console.log(chartData) 

    const handleTable= (value)=>{
        setGroupId(value)
        setRowData([])
        setChartData([])
        setChartExcel([])
        // chartRef.current = '';

    }
    
    return (

        loading &&!showData ? (
            <>
                <Skeleton active paragraph={{ rows: 6 }} />
            </>
        ) : (
            <div>
                <h4 className={`text-center text-[20px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>GROUP REPORT</h4>
                <Card className={`w-full h-auto dark ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} `}>
                    <p className={`font-[600] text-[18px] dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>SELECTION</p>

                    <Form onFinish={handleCreateReport}>
                        <div className='flex gap-5 mt-5 '>
                            <div className="flex gap-8">
                                <div className=''>
                                <div className="'flex'">
                                <label className={` mr-3 ${isdarkMode ? 'darkfont' : 'whitemode'}`}>Group Name</label>
                                    <Form.Item
                                        // label="Group Name"
                                        name="groupname"
                                        className={` ${isdarkMode ? 'darktext' : 'lighttext'}`}
                                        rules={[{ required: true, message: "Please select Group Name!" }]}
                                    >
                                        <Select
                                            mode="multiple"
                                            placeholder="Select Group Name"
                                            onChange={(value) => handleTable(value)}
                                            style={{ width: "310px" }}
                                            showSearch
                                            filterOption={(input, option) => {
                                                return option.children.toLowerCase().includes(input.toLowerCase());
                                            }}
                                            maxTagCount={2}
                                            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
                                            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
                                        >
                                            {groupname.map((group) => (
                                                <Select.Option key={group.groupID} value={group.groupID}>
                                                    {group.department}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    </div>
                                    <div className="flex-col">
                                    {!isLast24Hours && (
                                        <div className=' flex-col'>
                                            <div className=" flex flex-col">
                                                {/* <div><label className={` dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>From Date:</label></div> */}
                                                  <label className={` mr-5  ${isdarkMode ? 'darkfont' : 'whitemode'}`}>From Date</label>
                                                <Form.Item
                                                    name="FromDate"
                                                    // label="From Date"
                                                    rules={[{ required: true, message: "Please select From Date!" }]}
                                                    className={`dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}
                                                >
                                                  
                                                    <DatePicker
                                                        value={fromDateObj}
                                                        onChange={onChangeFromDate}
                                                        // onChange={(date, dateString) => setFromDateString(dateString)}
                                                        className={`${isdarkMode ? 'datebackground' : 'whitemode'} ml-0`}
                                                        dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
                                                        showTime={{ format: "HH:mm:ss" }}
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        style={{ width: "310px" }}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className=" flex flex-col">
                                                {/* <div><label className={` dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>To Date:</label></div> */}
                                                 <label className={` mr-7  ${isdarkMode ? 'darkfont' : 'whitemode'}`}>To Date</label>
                                                <Form.Item
                                                    name="ToDate"
                                                    className={`dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}
                                                    // label="To Date"
                                                    rules={[{ required: true, message: "Please select To Date!" }]}
                                                >
                                                   
                                                    <DatePicker
                                                        value={toDateObj}
                                                        // onChange={(date, dateString) => setToDateString(dateString)}
                                                        onChange={onChangeToDate}
                                                        className={`${isdarkMode ? 'datebackground' : 'whitemode'} ml-0`}
                                                        dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
                                                        showTime={{ format: "HH:mm:ss" }}
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        style={{ width: "310px" }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                </div>
                            <div className=' flex gap-2 mt-5'>
                                <div>
                                    <Checkbox checked={isLast24Hours} onChange={handleCheckboxChange} className="cursor-pointer"></Checkbox>
                                </div>
                                <div>
                                    <label className={` dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>Last 24 hours</label>
                                </div>
                            </div>
                            </div>
                            <Button type="primary" htmlType="submit" className="blue-btn ml-10">
                                Create Report
                            </Button>
                        </div>
                    </Form>
                </Card>
                {
                    showData&&(
                    <Card className={`w-full h-auto dark ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} mt-10`}>
                        <div className="flex justify-between items-center">
                        <p className={`font-[600] text-[18px] dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>GRID VIEW</p>
                        <Button type="primary" onClick={()=>exportToExcel(chartExcel,excelFromDate,excelToDate)} className="blue-btn ml-10">
                                Create Excel
                            </Button>
                        </div>
                        <div className={`${isdarkMode ? "dark-table" : "white-table "}`} style={{ width: '100%' }}>
                            <Table
                                columns={columns}
                                dataSource={rowData}
                                rowKey="groupID"
                                pagination={false}
                                rowHoverable={false}
                                className={`${isdarkMode ? "dark-table" : "white-table "}`}
                                expandable={{
                                    expandedRowRender,
                                    rowExpandable: (record) => {
                                        const subgroupData = subGroupData.filter(subgroup => subgroup.groupID === record.groupID);
                                        return subgroupData.length > 0;
                                    },
                                }}
                            />
                        </div>
                    </Card>
                    )
                }

                {
                    showData&&(
                    <Card className={`w-full h-auto dark  ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} mt-10`}>
                        <p className={`font-[600] text-[18px] dark ${mode.isdarkMode ? 'darkfont' : 'whitemode'}`}>PIECHART</p>
                        <div ref={chartRef} className="w-full h-full sm:h-[300px] md:h-[400px] lg:h-[500px]"></div>
                    </Card>
                    )
                }
            </div>
        )


    )
}

export default GroupReport